import moment from 'moment'
import { Counterparty } from 'entities/counterparties/model'
import { ContactDTO } from 'entities/counterparties/model/dtoTypes'

export const getInitialValuesPersonal = (data: Counterparty) => ({
    id: data?.id,
    type: data?.type,
    phone: data?.phone || '',
    email: data?.email || '',
    is_black_list: data?.isBlackList,
    comment: data?.comment || '',
    additional_data: {
        documents: {
            serial: data?.additionalData?.documents?.serial || '',
            division_code: data?.additionalData?.documents?.divisionCode || '',
            issued_by: data?.additionalData?.documents?.issuedBy || '',
            issue_date: data?.additionalData?.documents?.issueDate || '',
            city: data?.additionalData?.documents?.city || '',
            street: data?.additionalData?.documents?.street || '',
            house_number: data?.additionalData?.documents?.houseNumber || '',
            apartment_number:
                data?.additionalData?.documents?.apartmentNumber || '',
            index: data?.additionalData?.documents?.index || '',
        },
    },
    created_at: moment(data?.createdAt).format('DD.MM.YYYY'),
    discount: data?.discount || 0,
    profile_photo: {
        hash_name: data?.profilePhoto?.hashName || '',
        read_url: data?.profilePhoto?.readUrl || '',
    },
    document_photos: data?.documentPhotos,
    contact: {
        surname: data?.contact?.surname || '',
        first_name: data?.contact?.firstName || '',
        patronymic: data?.contact?.patronymic || '',
        phone: data?.contact?.phone || '',
        email: data?.contact?.email || '',
    },
    contacts: data?.contacts,
})

export const getInitialValuesCompany = (
    data: Counterparty,
    defaultContacts?: ContactDTO[],
) => ({
    id: data?.id,
    type: data?.type,
    phone: data?.phone || '',
    email: data?.email || '',
    is_black_list: data?.isBlackList,
    comment: data?.comment || '',
    created_at: moment(data?.createdAt).format('DD.MM.YYYY'),
    discount: data?.discount || 0,
    additional_data: {
        documents: {
            organization_name:
                data?.additionalData?.documents?.organizationName || '',
            inn: data?.additionalData?.documents?.inn || '',
            bank_name: data?.additionalData?.documents?.bankName || '',
            bik: data?.additionalData?.documents?.bik || '',
            kpp: data?.additionalData?.documents?.kpp || '',
            checking_account:
                data?.additionalData?.documents?.checkingAccount || '',
            legal_address: data?.additionalData?.documents?.legalAddress || '',
            registration_date:
                data?.additionalData?.documents?.registrationDate || '',
            correspondent_account:
                data?.additionalData?.documents?.correspondentAccount || '',
        },
    },
    profile_photo: {
        hash_name: data?.profilePhoto?.hashName || '',
        read_url: data?.profilePhoto?.readUrl || '',
    },
    document_photos: data?.documentPhotos,
    contact: {
        phone: data?.contacts?.[0]?.phone || '',
        email: data?.contacts?.[0]?.email || '',
        surname: data?.contacts?.[0]?.surname || '',
        first_name: data?.contacts?.[0]?.firstName || '',
        patronymic: data?.contacts?.[0]?.patronymic || '',
    },
    contacts: [
        ...data?.contacts?.map(contact => ({
            id: contact?.id,
            phone: contact?.phone || '',
            email: contact?.email || '',
            surname: contact?.surname || '',
            first_name: contact?.firstName || '',
            patronymic: contact?.patronymic || '',
        })) ?? [],
        ...defaultContacts ?? [],
    ],
})
